<template>
  <v-container>
    <!-- <v-row>
      <v-col cols="2">
        <v-select
          v-model="selectedFilter"
          :items="filters"
          item-text="state"
          label="Search By"
        ></v-select>
      </v-col>
    </v-row> -->
    <v-alert 
      type="error"
      :value="alert"
      dismissible
      transition="fade-transition">
      Sorry, something went wrong on our end :/
    </v-alert>
    <v-row align="center" justify="center" class="text-center ma-0 pa-0">
      <v-col>
        <v-text-field
          label="Search"
          clearable
          outlined
          rounded
          hide-details="auto"
          v-on:keyup.enter="searchHandler"
          v-model="search"
          :loading="loading">
        </v-text-field>
      </v-col>
      <v-col md="auto">
        <v-btn x-large rounded @click="searchHandler"> Search </v-btn>
      </v-col>
    </v-row>
    <v-alert 
      type="info"
      :value="resultsAlert"
      dismissible
      transition="fade-transition">
      No results found.
    </v-alert>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      url: process.env.VUE_APP_URL,
      loading: false,
      // items: [],
      search: null,
      // select: null,
      // filters: ["Company", "Market"],
      // selectedFilter: "Company",
      prompts: null,
      alert: false,
      resultsAlert: false,
    };
  },
  methods: {
    searchHandler() {
      let vm = this;
      if (vm.loading == false) {
        vm.loading = true;
        axios
          .get(`${vm.url}/startup/search?text=${vm.search}`)
          .then((response) => {
            if (response["data"].length == 0) {
              vm.resultsAlert = true;
            } else {
              vm.resultsAlert = false;
              vm.$emit("enterSearch", response["data"]);
            }
          })
          .catch(function (error) {
            // handle error
            console.log(error);
            vm.alert = true;
          })
          .then(function () {
            // always executed
            vm.loading = false;
          });
      }
    },
  },
};
</script>